import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Video } from 'lucide-react';

interface Props {
  videoUrl: string;
  setVideoUrl: (v: string) => void;
  videoMinutoInicio: string;
  setVideoMinutoInicio: (v: string) => void;
  videoMinutoFim: string;
  setVideoMinutoFim: (v: string) => void;
}

export function FieldsVideoAula({
  videoUrl, setVideoUrl,
  videoMinutoInicio, setVideoMinutoInicio,
  videoMinutoFim, setVideoMinutoFim,
}: Props) {
  return (
    <div className="rounded-lg border border-border p-4 bg-muted/30 space-y-4">
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded-md bg-primary/10">
          <Video className="h-4 w-4 text-primary" />
        </div>
        <div>
          <Label className="text-base font-medium">Vídeo Aula</Label>
          <p className="text-xs text-muted-foreground">
            Registre o vídeo assistido (opcional)
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <Label>URL do vídeo</Label>
        <Input
          type="url"
          inputMode="url"
          maxLength={500}
          placeholder="https://youtube.com/watch?v=..."
          value={videoUrl}
          onChange={(e) => setVideoUrl(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>Minutagem assistida</Label>
        <div className="grid grid-cols-2 gap-2">
          <Input
            type="number"
            min={0}
            value={videoMinutoInicio}
            onChange={(e) => setVideoMinutoInicio(e.target.value)}
            placeholder="Início (min)"
          />
          <Input
            type="number"
            min={0}
            value={videoMinutoFim}
            onChange={(e) => setVideoMinutoFim(e.target.value)}
            placeholder="Fim (min)"
          />
        </div>
      </div>
    </div>
  );
}
